var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatCentered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6953 15.3047L10.5391 17.2344C10.4824 17.3265 10.4032 17.4025 10.3088 17.4553C10.2144 17.508 10.1081 17.5357 10 17.5357C9.89189 17.5357 9.78558 17.508 9.69121 17.4553C9.59684 17.4025 9.51756 17.3265 9.46094 17.2344L8.30469 15.3047C8.2503 15.2121 8.17269 15.1352 8.07952 15.0818C7.98635 15.0284 7.88084 15.0002 7.77344 15H3.125C2.95924 15 2.80027 14.9342 2.68306 14.8169C2.56585 14.6997 2.5 14.5408 2.5 14.375V4.375C2.5 4.20924 2.56585 4.05027 2.68306 3.93306C2.80027 3.81585 2.95924 3.75 3.125 3.75H16.875C17.0408 3.75 17.1997 3.81585 17.3169 3.93306C17.4342 4.05027 17.5 4.20924 17.5 4.375V14.375C17.5 14.5408 17.4342 14.6997 17.3169 14.8169C17.1997 14.9342 17.0408 15 16.875 15H12.2266C12.1192 15.0002 12.0137 15.0284 11.9205 15.0818C11.8273 15.1352 11.7497 15.2121 11.6953 15.3047V15.3047Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCentered);
export default __webpack_public_path__ + "static/media/chat-centered.d2455988889d1725f3b355682c1796b4.svg";
export { ForwardRef as ReactComponent };